import isFocused from "./isFocused.js";
import togglePlaceholder from "./togglePlaceholder.js";

export default (element, value) => {
    if (!element || isFocused(element)) return;

    if (element.dataset && element.dataset.theme === 'snow') return;

    const quill = element.querySelector('.ra-quill');
    quill.innerHTML = value;

    togglePlaceholder(element);
};